import { render } from "./metricBoxFacade.vue?vue&type=template&id=66c6aff0&scoped=true"
import script from "./metricBoxFacade.vue?vue&type=script&lang=js"
export * from "./metricBoxFacade.vue?vue&type=script&lang=js"

import "./metricBoxFacade.vue?vue&type=style&index=0&id=66c6aff0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c6aff0"]])

export default __exports__